module.exports = __webpack_public_path__ + "/public/images/3861e9eb08528ed839cf22c3d51e2042.png";